import { useQuery } from "@apollo/client/react"; import React, { useEffect, useState, useMemo } from 'react';
import { Button, Grid } from '@mui/material';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';

export const StepCuidadosDomiciliarios = ({
  esAdulto,
  selectedPrograms,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI
}) => {
  const [cuidadosDomiciliarios, setCuidadosDomiciliarios] = useState(fullFormDataRI?.cuidadosDomiciliarios1 ?? {});
  const [combosRI, setCombosRI] = useState();

  const handleSubmit = () => {
    updateFormData('cuidadosDomiciliarios1', cuidadosDomiciliarios, validatedinputsGroups.flatMap((x) => x.inputs));
  };

  const handleChange = (name, value) => {
    if (name === 'idComboRIValorCalendarioVacunas')
      value = parseInt(value);

    setCuidadosDomiciliarios((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const handleChangeImage = (name, value) => {
    obtenerDataImagen(value).then((image) => {
      handleChange(name,
        {
          contentType: image?.tipo,
          archivo: image?.data,
          extension: image?.extension,
          titulo: image?.nombre
        }
      );
    });
  };

  const onDeleteImage = (name) => {
    handleChange(name, null);
  };

  const getOptionsByName = (fieldName) => {
    const combos = {
      'idComboRIValorCalendarioVacunas': combosRI?.idComboRIValorCalendarioVacunas.map((e) => { return { label: e.displayName, value: e.id }; }),

      'idComboRIValorAduKarnofsky': combosRI?.idComboRIValorAduKarnofsky,
      'idComboRIValorPedLansky': combosRI?.idComboRIValorPedLansky
    };

    return combos[fieldName] || [];
  };

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const validatedinputsGroups = useMemo(() => {
    const updatedRequired = inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((prevInput) => {
        const input = {
          ...prevInput,
          options: prevInput.type == "select" || prevInput.type.includes("multiple") ? getOptionsByName(prevInput.name) : []
        };

        switch (input.name) {
          case "videodeglucionAdjunto":
            if (!cuidadosDomiciliarios.videodeglucion)
              onDeleteImage(input.name);
            return {
              ...input,
              hidden: !cuidadosDomiciliarios?.videodeglucion,
              required: !!cuidadosDomiciliarios?.videodeglucion
            };
          case 'idComboRIValorAduKarnofsky':
            if (!esAdulto) handleChange(input.name, null);
            return {
              ...input,
              hidden: !esAdulto,
              required: esAdulto
            };
          case 'idComboRIValorPedLansky':
            if (esAdulto) handleChange(input.name, null);
            return {
              ...input,
              hidden: esAdulto,
              required: !esAdulto
            };
          default:
            return input;
        }
      })
    }));

    return updatedRequired;
  }, [selectedPrograms, esAdulto, combosRI, cuidadosDomiciliarios.videodeglucion]);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [cuidadosDomiciliarios, setDataSubmissionCallback, validatedinputsGroups]);

  return (
    <div>
      {/* <p className='step-form-section-title'>Condiciones del paciente para el inicio</p> */}
      {validatedinputsGroups.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className='step-form-section-title'>{group.subGroupName ? group.subGroupName : group.groupName}</label>
          <Grid
            container>
            {group.inputs.filter((i) => !i.hidden).map((input) => {
              return (
                <RenderInputByTypeMobile
                  key={`${group.groupName}-${input.name}`}
                  grided
                  handleChange={input.type === 'file' ? handleChangeImage : handleChange}
                  handleDelete={() => onDeleteImage(input.name)}
                  input={input}
                  value={cuidadosDomiciliarios[input.name]} />);


            })}
          </Grid>
        </div>
      )
      }
    </div>);

};

export default StepCuidadosDomiciliarios;

const inputsGroups = [
  {
    groupName: 'Examen Fisico',
    inputs: [
      {
        displayName: 'SNC',
        name: 'sNC',
        type: 'long_string',
        required: true
      },
      {
        displayName: 'CV',
        name: 'cV',
        type: 'long_string',
        required: true
      },
      {
        displayName: 'Respiratorio',
        name: 'respiratorio',
        type: 'long_string',
        required: true
      },
      {
        displayName: 'Digestivo',
        name: 'digestivo',
        type: 'long_string',
        required: true
      },
      {
        name: "videodeglucion",
        displayName: "Videodeglución",
        type: "boolean",
        required: true,
        lightTitle: true
      },
      {
        name: "videodeglucionAdjunto",
        displayName: "Informe de Videodeglución",
        type: "file"
      },
      {
        displayName: 'Otros',
        name: 'otros',
        type: 'long_string',
        required: false
      },
      {
        displayName: 'Traqueostomía',
        name: 'traqueostomia',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Sonda vesical',
        name: 'sondaVesical',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Ostomía',
        name: 'ostomia',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Catéter',
        name: 'cateter',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Sonda nasogástrica',
        name: 'sondaNasogastrica',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Calendario vacunas completo',
        comboName: 'Calendario de Vacunas',
        name: 'idComboRIValorCalendarioVacunas',
        type: 'multiple_boolean',
        required: true,
        options: []
      },
      {
        displayName: 'Karnofsky',
        comboName: 'Karnofsky',
        name: 'idComboRIValorAduKarnofsky',
        type: 'select',
        required: true,
        options: []
      },
      {
        displayName: 'Escala LANSKY',
        comboName: 'ESCALA DE LANSKY ',
        name: 'idComboRIValorPedLansky',
        type: 'select',
        required: true,
        options: []
      },
      {
        displayName: 'Requiere Soporte Nutricional',
        name: 'requiereSoporteNutricional',
        type: 'boolean',
        required: true
      }]

  }];